<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="Single-Item-Select" type="checkbox" value=""
                        v-model="compState.autoStock">
                    <label class="form-check-label" for="Single-Item-Select">Auto-stock</label>
                </div>
            </div>
        </div>
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="Show-on-Menu" type="checkbox" value=""
                        v-model="compState.returnsCanBeRestocked">
                    <label class="form-check-label" for="Show-on-Menu">Returns can be restocked</label>
                </div>
            </div>
        </div>
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="Stock-Source" type="checkbox" value=""
                        v-model="compState.stockSource">
                    <label class="form-check-label" for="Stock-Source">Stock Source</label>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Stock Location</h6>
                </label>
                <input v-model="compState.stockLocation" class="form-control" type="text" placeholder="Name"
                    maxlength="32">
            </div>
        </div>
        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">Stock Low Watermark</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" placeholder="Threshold" v-model="compState.stockLowWatermark">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="stockLowWatermarkDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="stockLowWatermarkIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">Stock High Watermark</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" placeholder="Threshold"
                    v-model="compState.stockHighWatermark">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="stockHighWatermarkDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="stockHighWatermarkIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">Sale to Stock Unit Ratio</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" placeholder="Threshold"
                    v-model="compState.saleToStockUnitRatio">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="saleToStockUnitRatioDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="saleToStockUnitRatioIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-6">
            <div class="mb-3">
                <h6 class="f-w-700 pb-1">Current Stock Level : {{ compState.currentStockLevel }}</h6>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Sale Unit</h6>
                </label>
                <select v-model="compState.saleUnit" class="form-select" aria-label="Sale Unit">
                    <option value="" disabled>Sale Unit</option>
                    <option value="Individually">Individually</option>
                    <option value="Gram">Gram (g)</option>
                    <option value="Kilogram">Kilogram (kg)</option>
                    <option value="Milligram">Milligram (mg)</option>
                    <option value="Ounce">Ounce (oz)</option>
                    <option value="Pound">Pound (lb)</option>
                    <option value="Carat">Carat (ct)</option>
                </select>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Stock Unit</h6>
                </label>
                <select v-model="compState.stockUnit" class="form-select" aria-label="Stock Unit">
                    <option value="" disabled>Stock Unit</option>
                    <option value="Individually">Individually</option>
                    <option value="Gram">Gram (g)</option>
                    <option value="Kilogram">Kilogram (kg)</option>
                    <option value="Milligram">Milligram (mg)</option>
                    <option value="Ounce">Ounce (oz)</option>
                    <option value="Pound">Pound (lb)</option>
                    <option value="Carat">Carat (ct)</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const stockData = productGroup.stock
        compState.autoStock = stockData.autoStock
        compState.returnsCanBeRestocked = stockData.returnsCanBeRestocked
        compState.stockSource = stockData.stockSource
        compState.stockLocation = stockData.stockLocation
        compState.stockLowWatermark = stockData.stockLowWatermark
        compState.stockHighWatermark = stockData.stockHighWatermark
        compState.saleToStockUnitRatio = stockData.saleToStockUnitRatio
        compState.currentStockLevel = stockData.currentStockLevel
        compState.saleUnit = stockData.saleUnit
        compState.stockUnit = stockData.stockUnit
    }
})

const compState = reactive({
    autoStock: false,
    returnsCanBeRestocked: false,
    stockSource: false,
    stockLocation: '',
    stockLowWatermark: 0,
    stockHighWatermark: 0,
    saleToStockUnitRatio: 0,
    currentStockLevel: 0,
    saleUnit: '',
    stockUnit: ''
})


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const stockData = productGroup.stock
        compState.autoStock = stockData.autoStock
        compState.returnsCanBeRestocked = stockData.returnsCanBeRestocked
        compState.stockSource = stockData.stockSource
        compState.stockLocation = stockData.stockLocation
        compState.stockLowWatermark = stockData.stockLowWatermark
        compState.stockHighWatermark = stockData.stockHighWatermark
        compState.saleToStockUnitRatio = stockData.saleToStockUnitRatio
        compState.currentStockLevel = stockData.currentStockLevel
        compState.saleUnit = stockData.saleUnit
        compState.stockUnit = stockData.stockUnit
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        stock: {
            autoStock: newVal.autoStock,
            returnsCanBeRestocked: newVal.returnsCanBeRestocked,
            stockSource: newVal.stockSource,
            stockLocation: newVal.stockLocation,
            stockLowWatermark: newVal.stockLowWatermark,
            stockHighWatermark: newVal.stockHighWatermark,
            saleToStockUnitRatio: newVal.saleToStockUnitRatio,
            currentStockLevel: newVal.currentStockLevel,
            saleUnit: newVal.saleUnit,
            stockUnit: newVal.stockUnit
        }
    })

}, { deep: true });

const stockLowWatermarkIncrement = () => {
    compState.stockLowWatermark++
}

const stockLowWatermarkDecrement = () => {
    if (compState.stockLowWatermark > 0) {
        compState.stockLowWatermark--
    }
}
const stockHighWatermarkIncrement = () => {
    compState.stockHighWatermark++
}

const stockHighWatermarkDecrement = () => {
    if (compState.stockHighWatermark > 0) {
        compState.stockHighWatermark--
    }
}
const saleToStockUnitRatioIncrement = () => {
    compState.saleToStockUnitRatio++
}

const saleToStockUnitRatioDecrement = () => {
    if (compState.saleToStockUnitRatio > 0) {
        compState.saleToStockUnitRatio--
    }
}

</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>